<template>
	<div class="info-layout">
		<!-- 左侧企业logo 等展示框 -->
		<div class="left-show">
			<img :src="`${uploadUrl}${imgUrl.logoUrl}`" alt="企业Logo" @click="openBig(imgUrl.logoUrl)" />
			<p>企业logo</p>
			<img :src="`${uploadUrl}${imgUrl.licenseUrl}`" alt="营业执照" @click="openBig(imgUrl.licenseUrl)" />
			<p>企业证件</p>
			<img :src="`${uploadUrl}${imgUrl.entrustUrl}`" alt="企业委托函" @click="openBig(imgUrl.entrustUrl)" />
			<p>企业委托函</p>

			<p>
				附件：<a
					class="agreement-text"
					href="javascript:;"
					@click="handleDeal(item)"
					v-for="(item, index) in agreement"
					:key="'agree' + index"
					>{{ item.sname }}</a
				>
			</p>
		</div>
		<div class="right-info">
			<div class="overflow-y h100">
				<div class="top-box">
					<h4 class="title">
						{{ baseForm.sname }}
						<span class="blue-text">{{ baseForm.agent === '' ? '（法人代表注册）' : '（代理注册）' }}</span>
					</h4>
					<div class="content">
						<el-row>
							<el-col :span="10">
								<span class="label">创建人：</span>
								{{ baseForm.createUserName }}
							</el-col>
							<el-col :span="10">
								<span class="label">创建时间：</span>
								{{ baseForm.createDate }}
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="10">
								<span class="label">单位类型：</span>
								{{ baseForm.flatTypeName }}
							</el-col>
							<el-col :span="10">
								<span class="label">统一社会信用代码：</span>
								{{ baseForm.creditCode }}
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="10">
								<span class="label">法人代表姓名：</span>
								{{ baseForm.legal }}
							</el-col>
							<el-col :span="10">
								<span class="label">法人代表手机号：</span>
								{{ baseForm.legalPhone }}
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="10">
								<span class="label">法人代表证件类型：</span>
								身份证
							</el-col>
							<el-col :span="10">
								<span class="label">法人代表证件号：</span>
								{{ baseForm.legalNo }}
							</el-col>
						</el-row>
						<div class="divider"></div>
						<!-- 代理人 -->
						<el-row>
							<el-col :span="10">
								<span class="label">代理人姓名：</span>
								{{ baseForm.agent }}
							</el-col>
							<el-col :span="10">
								<span class="label">代理人手机号：</span>
								{{ baseForm.agentPhone }}
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="10">
								<span class="label">代理人证件类型：</span>
								身份证
							</el-col>
							<el-col :span="10">
								<span class="label">代理人身份证号：</span>
								{{ baseForm.agentNo }}
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="10">
								<span class="label">企业简称：</span>
								{{ baseForm.shortName }}
							</el-col>
							<el-col :span="10" class="flex">
								<span class="label">注册地址：</span>
								<span>{{ baseForm.registAdd }}</span>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="24">
								<span class="label">企业开通相关业务：</span>
								<el-tooltip effect="dark" :content="objState.caStatus == 1 ? '已申请CA' : '未申请CA'" placement="top">
									<svg-icon
										icon-class="CA-rz"
										class="icon"
										:class="{ purple: objState.caStatus === 1 }"
										@click="handleClick('CA', objState.caStatus)"
									></svg-icon>
								</el-tooltip>
								<el-tooltip effect="dark" content="电子发票" placement="top">
									<svg-icon
										icon-class="apply-invoice"
										class="icon width25"
										:class="{ blue: objState.invoiceStatus === 1 }"
										@click="handleClick('invoice', objState.invoiceStatus)"
									></svg-icon>
								</el-tooltip>

								<el-tooltip effect="dark" content="安招采电子招投标系统" placement="top">
									<svg-icon
										:icon-class="objState.aczStatus == 1 ? 'logo_anzhaocai' : 'logo_anzhaocai_huise'"
										class="icon width25 height25"
										@click="handleClick('azc', objState.aczStatus)"
									></svg-icon>
								</el-tooltip>

								<el-tooltip effect="dark" content="企业资金账户" placement="top">
									<svg-icon
										icon-class="company-account"
										class="icon"
										:class="{ blue: objState.applyAccount == 1 }"
										@click="handleClick('account', objState.applyAccount)"
									></svg-icon>
								</el-tooltip>
							</el-col>
						</el-row>
					</div>
				</div>

				<!-- 企业基本信息 -->
				<el-tabs v-model="currentTab" @tab-click="onTabClick">
					<el-tab-pane v-for="(item, index) in tabsList" :key="'tab' + index" :label="item.label" :name="item.name">
						<!-- 基本信息 -->
						<tab-content ref="tabCont" :currentTab="currentTab" v-if="parseInt(currentTab) === index" :tabData="tabData"></tab-content>
					</el-tab-pane>
				</el-tabs>
				<!-- 企业信息变更记录 -->
				<h4 class="tab-title">企业信息变更记录</h4>
				<div class="overflow-x overflow-y">
					<el-table border :data="recordsList" size="small" resizable highlight-hover-row>
						<el-table-column prop="content" label="变更内容" min-width="200" align="center">
							<template slot-scope="scope">
								<el-button type="text" @click="viewDetail(scope.row)">查看</el-button>
							</template>
						</el-table-column>
						<el-table-column prop="createDate" label="变更时间" min-width="200" align="center"></el-table-column>
						<el-table-column prop="createName" label="操作人" min-width="200" align="center" show-overflow-tooltip> </el-table-column>
					</el-table>
				</div>
			</div>
		</div>

		<!-- 入驻协议弹窗 -->
		<el-dialog width="800px" center :title="newAgreement.sname" :visible.sync="assortmentVisible">
			<p v-html="newAgreement.content"></p>
		</el-dialog>

		<!-- 小图标弹窗 -->
		<el-dialog :visible.sync="dialogObj.visible" :width="dialogObj.width" :title="dialogObj.title">
			<!-- 企业实名 -->
			<!--<qy-real :viewId="$route.query.tenantId"
                     :companyId="$route.query.tenantId" :rowData="{type: 6}" v-if="dialogObj.type === 'company'"></qy-real>-->
			<!-- 详情 -->
			<show-info
				:creditCode="baseForm.creditCode"
				:caData="caData"
				:curType="curViewType"
				:recordId="recordId"
				:companyName="baseForm.sname"
				:accountList="accountList"
				:fileObj="fileObj"
				:baseInfo="baseInfo"
				v-if="dialogObj.visible"
			></show-info>
		</el-dialog>

		<!-- 预览大图 -->
		<el-dialog :visible.sync="imgVisible" title="查看" center width="1200px">
			<div class="text-center">
				<img :src="`${uploadUrl}${currentImg}`" alt="" />
			</div>
		</el-dialog>

		<!-- 审核企业申请 -->
		<el-dialog
			:title="companyDialog.title"
			:visible.sync="companyDialog.show"
			width="1000px"
			:close-on-click-modal="false"
			center
			append-to-body
			class="audit-company-dialog"
			top="4vh"
		>
			<qyDialog
				v-if="companyDialog.show"
				ref="qyDialog"
				:rowData="changeRow"
				mode="view"
				audit="1002049007"
				:hideAudit="true"
			></qyDialog>
		</el-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import tabContent from './tab-content'

import showInfo from './show-info'
import qyDialog from '@/views/operation-management/audit-affairs-new/components/qy-dialog'

import * as Api from 'api/modules/enterprises_new'
import { getDealDetail } from 'api/modules/rulesManagement'

export default {
	name: 'company-info',
	components: {
		tabContent,
		showInfo,
		qyDialog
	},
	props: {},
	data() {
		return {
			baseForm: {},
			imgUrl: {
				logoUrl: '', // logo
				licenseUrl: '', // 营业执照
				entrustUrl: ''
			},
			imgVisible: false, // 大图
			currentImg: '',
			currentTab: '0',
			tabsList: [
				{
					label: '基本信息',
					name: '0'
				},
				{
					label: '证照信息',
					name: '1'
				},
				{
					label: '证明材料',
					name: '2'
				},
				{
					label: '财务状况',
					name: '3'
				},
				{
					label: '资质信息',
					name: '4'
				},
				{
					label: '项目案例',
					name: '5'
				},
				{
					label: '组织人员',
					name: '6'
				},
				{
					label: '业务板块负责人',
					name: '7'
				}
			],
			tabData: null,
			baseInfo: null,
			// 变更记录
			recordsList: [],
			// 协议弹窗
			assortmentVisible: false,
			// 小图标弹窗
			dialogObj: {
				visible: false,
				type: '',
				title: '',
				width: '1000px'
			},
			curViewType: '',
			caData: [],
			recordId: [],
			// 企业账户
			accountList: [
				{
					isFlag: -1,
					key: '1001',
					type: 0,
					sname: '设置企业基本信息'
				},
				{
					isFlag: -1,
					key: '1002',
					type: 3,
					sname: '签署会员协议'
				},
				{
					isFlag: -1,
					key: '1003',
					type: 4,
					sname: '绑定手机号'
				},
				{
					isFlag: -1,
					key: '1004',
					type: 1,
					sname: '上传影像材料',
					title: '（当前步骤，影像资料上传平台会进行审核）'
				}
			],
			fileObj: {
				idCardZ_Url: '',
				idCardF_Url: '',
				license_zz_Url: ''
			},
			agreement: [], // 入驻协议
			newAgreement: [], // 点击查看的入驻协议
			// 变更内容查看
			companyDialog: {
				show: false,
				title: ''
			},
			changeRow: {}
		}
	},
	created() {
		this.getDealsByScene()
		this.getCompanyInfo()
	},
	methods: {
		// 获取企业信息
		getCompanyInfo() {
			Api.selectCompanyInfo({ tenantId: this.$route.query.tenantId, userId: this.userId, type: 0 })
				.then((res) => {
					this.imgUrl.logoUrl = res.data.files.logoUrl
					this.imgUrl.licenseUrl = res.data.files.licenseUrl
					this.imgUrl.entrustUrl = res.data.files.entrustUrl
					this.baseInfo = res.data
					this.onTabClick()
					this.recordsList = res.data.records
					// 基本信息
					this.baseForm = res.data
					// CA
					this.caData = res.data.CA_Info
					// 安招采
					this.recordId = res.data.recordId || []
					// 企业账户相关
					if (res.data.applyAccounts && res.data.applyAccounts.length > 0) {
						res.data.applyAccounts.map((x) => {
							let _item = this.accountList.find((y) => y.type === x.type)
							_item ? (_item.isFlag = x.state) : ''

							if (_item.type === 0) {
								_item.accountInfo = x.accountInfo
							}

							if (_item.type === 4) {
								_item.bindPhone = x.bindPhone
							}
						})
					}
					// 影像件地址
					if (res.data.files.idCardF_Url) {
						this.fileObj.idCardF_Url = res.data.files.idCardF_Url
					}
					if (res.data.files.idCardZ_Url) {
						this.fileObj.idCardZ_Url = res.data.files.idCardZ_Url
					}
					if (res.data.files.license_zz_Url) {
						this.fileObj.license_zz_Url = res.data.files.license_zz_Url
					}
				})
				.catch((err) => {})
		},

		// 点击切换tab
		onTabClick() {
			if (parseInt(this.currentTab) === 0) {
				this.tabData = this.baseInfo
			}
			if (parseInt(this.currentTab) < 6 && parseInt(this.currentTab) > 0) {
				let params = {
					type: parseInt(this.currentTab),
					tenantId: this.$route.query.tenantId,
					userId: this.userId
				}
				Api.selectCompanyInfo(params)
					.then((res) => {
						this.tabData = res.data
					})
					.catch((err) => {})
			}

			// 组织人员 5
			if (parseInt(this.currentTab) === 6) {
				Api.getOrganization({ tenantId: this.$route.query.tenantId })
					.then((res) => {
						this.tabData = res.data
					})
					.catch((err) => {
						this.tabData = []
					})
			}

			// 业务板块负责人
			if (parseInt(this.currentTab) === 7) {
				Api.getBusPrincipals({ tenantId: this.$route.query.tenantId })
					.then((res) => {
						this.tabData = res.data.busPrincipals
					})
					.catch((err) => {
						this.tabData = []
					})
			}
		},

		// 点击小图标
		handleClick(type, status) {
			//   if (!status) {
			//     return;
			//   }
			//   this.dialogObj.type = type;
			//   this.dialogObj.visible = true;
			//   this.curViewType = type;
			//   switch (type) {
			//     case "company":
			//       this.dialogObj.title = "企业信息查看";
			//       break;
			//     case "CA":
			//       this.dialogObj.title = "查看";
			//       break;
			//     case "invoice":
			//       this.dialogObj.title = "查看";
			//       break;
			//     case "account":
			//       this.dialogObj.title = "查看企业资金账户";
			//       break;
			//     case "azc":
			//       this.dialogObj.title = "查看安招采主体身份业务";
			//       break;
			//   }
		},

		// 打开大图
		openBig(url) {
			if (url && url !== '') {
				this.imgVisible = true
				this.currentImg = url
			}
		},

		// 根据应用场景获取协议
		getDealsByScene() {
			Api.getDealsByScene({
				userId: this.userId,
				sceneApply: 1001029019
			})
				.then((res) => {
					//  console.log(res);
					this.agreement = res.data
				})
				.catch((err) => {})
		},

		// 点击详情协议
		handleDeal(val) {
			this.newAgreement.sname = val.sname
			getDealDetail({
				userId: this.userId,
				dealId: val.dealId
			}).then((res) => {
				this.newAgreement.content = res.data
				this.assortmentVisible = true
			})
		},

		// 查看变更内容详情
		viewDetail(row) {
			this.changeRow = row
			this.companyDialog.show = true
			this.companyDialog.title = '企业变更内容'
		}
	},
	computed: {
		// 上传接口地址
		uploadUrl() {
			return this.$uploadUrl
		},
		objState() {
			return JSON.parse(this.$getSessionItem('objState'))
		},
		...mapState('user', {
			userId: (state) => state.userInfo.id
		})
	}
}
</script>

<style scoped lang="less">
.info-layout {
	height: 100%;
	color: #666;
	display: flex;

	@length: 30px;

	.left-show {
		width: 240px;
		height: 100%;
		/*border-right: 1px dotted #ccc;*/
		overflow: hidden;
		flex: 0 1 auto;

		img {
			display: block;
			width: 180px;
			height: 120px;
			margin: @length auto 0;
			background: #fbfdff;
			border: 1px solid #c2dcfb;
			border-radius: 6px;
		}

		p {
			width: 100%;
			text-align: center;
			font-size: 16px;
			line-height: 32px;
		}

		.agreement-text {
			display: inline-block;
			margin-top: 50px;
			color: #1c78c0;
			text-decoration: underline;
		}
	}

	.right-info {
		flex: 1;
		height: 100%;
		padding: @length 20px @length 0;
		overflow: hidden;

		.top-box {
			border: 1px solid #c2dcfb;
			background: #fbfdff;
			border-radius: 5px 5px 0 0;
			font-size: 14px;
			line-height: 30px;
			margin-bottom: 10px;
		}

		.title {
			color: #333;
			line-height: 40px;
			background-color: #eef4fb;
			border-bottom: 1px solid #c2dcfb;
			font-size: 14px;
			padding: 0 20px;
		}

		.blue-text {
			color: #2671cc;
			font-weight: 600;
		}

		.content {
			padding: 10px 20px;
			color: #000;
		}

		.label {
			color: #666;
			flex-shrink: 0;
		}

		.divider {
			border-bottom: 1px dashed #abd0fb;
			margin: 10px 0;
		}

		svg {
			font-size: 20px;
			vertical-align: middle;
			margin-top: -3px;
			margin-right: 15px;
			color: #c9c9c9;
			cursor: pointer;

			// &:nth-of-type(1) {
			//   font-size: 28px;
			// }

			// &:nth-of-type(5) {
			//   font-size: 28px;
			// }

			&.blue {
				color: #2671cc;
			}

			&.purple {
				color: #ae5da1;
			}

			&.yellow {
				color: #eb6100;
			}
		}

		.tab-title {
			color: #333;
			line-height: 40px;
			border-bottom: 1px solid #333;
			margin-bottom: 10px;
			margin-top: 0;
		}

		.overflow-y {
			padding-right: 20px;
		}
	}
}

.info-row {
	line-height: 40px;
	font-weight: 600;
}

.text-indent {
	line-height: 24px;
	text-indent: 2em;
}
</style>
